export default __webpack_public_path__ + "static/media/The Thirteenth Toll.4a1abc1d.png";